import axios from 'axios'
import prepareUrl from '@/store/modules/service-module/utils'

export const actions = {
  async getFileByRecId ({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      const isPublic = params && params.isPublic
      const query = params && params.query
      const url = prepareUrl(`/${isPublic ? 'public' : 'api/dpws'}/general-files/category/{:category}/{:rec-guid}${query ? '?' + query : ''}`, params)
      axios.get(url)
        .then(response => response.data)
        .then(({ error, data }) => {
          if (error) {
            return reject(error)
          }
          return resolve(data)
        }).catch(response => {
          const error = response && response.data && response.data.error
          return reject(error)
        })
    })
  },
  async getFileByCategory ({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      const isPublic = params && params.isPublic
      const url = prepareUrl(`/${isPublic ? 'public' : 'api/dpws'}/general-files/category/{:category}`, params)
      axios.get(url)
        .then(response => response.data)
        .then(({ error, data }) => {
          if (error) {
            return reject(error)
          }
          return resolve(data)
        }).catch(response => {
          const error = response && response.data && response.data.error
          return reject(error)
        })
    })
  },
  async removeFileByRecId ({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      const isPublic = params && params.isPublic
      const isProxy = params && params.isProxy
      const url = prepareUrl(`/${isPublic ? 'public' : isProxy ? 'api/de/proxy' : 'api/dpws'}/general-files/category/{:category}/{:rec-guid}/{:file-guid}`, params)
      axios.delete(url)
        .then(response => response.data)
        .then(({ error, data }) => {
          if (error) {
            return reject(error)
          }
          return resolve(data)
        }).catch(response => {
          const error = response && response.data && response.data.error
          return reject(error)
        })
    })
  },
  // /general-files/category/{:profile-category}/{:rec-id}/{:file-guid}
  async getFileById ({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      const isPublic = params && params.isPublic
      const url = prepareUrl(`/${isPublic ? 'public' : 'api/dpws'}/general-files/file/{:file-guid}?json=true`, params)
      axios.get(url)
        .then(response => response.data)
        .then(({ error, data }) => {
          if (error) {
            return reject(error)
          }
          return resolve(data)
        }).catch(response => {
          const error = response && response.data && response.data.error
          return reject(error)
        })
    })
  },
  async uploadFiles ({ commit, dispatch }, params) {
    commit('setUploadPending')
    return new Promise((resolve, reject) => {
      const url = `${__config.api_url}/api/dpws/general-files/add/category/${this.category}/${this.itemGuid}`
      axios.post(url, params.files, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(response => response.data)
        .then(({ error, data }) => {
          if (error) {
            dispatch('errors/populate', error, { root: true })
            return reject(error)
          }
          return resolve(data)
        })
        .catch(response => {
          const error = response && response.data && response.data.error
          dispatch('errors/populate', error, { root: true })
          return reject(error)
        }).finally(() => commit('unsetUploadPending'))
    })
  },
  async getLinks ({ commit }, params) {
    return new Promise((resolve, reject) => {
      const url = `${__config.api_url}/api/de/exams/${params.examGUID}/stream/links`
      axios.get(url)
        .then(response => response.data)
        .then(({ data }) => {
          return resolve(data)
        }).catch(response => {
          return reject(response)
        })
    })
  },
  async postLink ({ commit }, params) {
    return new Promise((resolve, reject) => {
      const url = `${__config.api_url}/api/de/exams/${params.examGUID}/stream/links`
      axios.post(url, { link: params.link }, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
        .then(response => response.data)
        .then(({ data }) => {
          return resolve(data)
        }).catch(response => {
          return reject(response)
        })
    })
  },
  async putLink ({ commit }, params) {
    return new Promise((resolve, reject) => {
      const url = `${__config.api_url}/api/de/exams/${params.examGUID}/stream/links/${params.guid}`
      axios.put(url, { link: params.link }, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
        .then(response => response.data)
        .then(({ data }) => {
          return resolve(data)
        }).catch(response => {
          return reject(response)
        })
    })
  },
  async deleteLink ({ commit }, params) {
    return new Promise((resolve, reject) => {
      const url = `${__config.api_url}/api/de/exams/${params.examGUID}/stream/links/${params.guid}`
      axios.delete(url)
        .then(response => response.data)
        .then(({ data }) => {
          return resolve(data)
        }).catch(response => {
          return reject(response)
        })
    })
  },
  async getComments ({ commit }, params) {
    return new Promise((resolve, reject) => {
      const url = `${__config.api_url}/api/de/exams/${params.examGUID}/comment`
      axios.get(url)
        .then(response => response.data)
        .then(({ data }) => {
          return resolve(data)
        }).catch(response => reject(response))
    })
  },
  async postComment ({ commit }, params) {
    return new Promise((resolve, reject) => {
      const url = `${__config.api_url}/api/de/exams/${params.examGUID}/comment`
      axios.post(url, { comment: params.comment }, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
        .then(response => response.data)
        .then(({ data }) => resolve(data))
        .catch(response => {
          return reject(response)
        })
    })
  },
  async putComment ({ commit }, params) {
    return new Promise((resolve, reject) => {
      const url = `${__config.api_url}/api/de/exams/${params.examGUID}/comment/${params.guid}`
      axios.put(url, { comment: params.comment }, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
        .then(response => response.data)
        .then(({ data }) => resolve(data))
        .catch(response => reject(response))
    })
  },
  async deleteComment ({ commit }, params) {
    return new Promise((resolve, reject) => {
      const url = `${__config.api_url}/api/de/exams/${params.examGUID}/comment/${params.guid}`
      axios.delete(url)
        .then(response => response.data)
        .then(({ data }) => resolve(data))
        .catch(response => reject(response))
    })
  }
}
